<template>
  <div class="full-height-global" :class="{'full-height-global-grow': ['goals', 'tasks'].includes(activePageCode)}">
    <modal v-show="showModal"></modal>
    <component :is="activePageCode"></component>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import modal from './../components/shared/modal/modal'
import landing from './../components/views/landing'
import project from './../components/views/project'
import goals from './../components/views/goals'
import tasks from './../components/views/tasks'
import results from './../components/views/results'
// import history from './../components/views/history'

export default {
  name: 'global',
  components: {
    modal,
    landing,
    project,
    goals,
    tasks,
    results
    // history
  },
  computed: {
    ...mapGetters({
      activePageCode: 'getActivePageCode',
      showModal: 'getShowModal'
    })
  }
}
</script>
